module.exports = __webpack_public_path__ + "img/iso-1.e47d3cb6.png";